module.exports = __webpack_public_path__ + "img/template-art@3x.24080957.png";